import styled from '@emotion/styled'
import { Button, Menu, MenuItem } from '@mui/material'

export const DropdownButton = styled(Button)({
  color: '#0000FF',
  backgroundColor: 'transparent',
  fontWeight: '600',
  fontSize: '16px',
  border: '1px solid transparent',
  transition: '0.5s',
  ':hover': {
    cursor: 'pointer',
    borderBottom: '1px solid'
  }
})

export const DropdownList = styled(Menu)({
  position: 'fixed',
  zIndex: '1',
  padding: `8px 0`,
  borderRadius: 4,
  backgroundColor: '#fff',
  boxShadow: '9px 8px 4px rgba(0, 0, 0, 0.2)',
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  minWidth: '160px',
  '&:active': {
    border: 'none'
  }
})

export const DropdownItem = styled(MenuItem)({
  whiteSpace: 'initial',
  fontFamily: 'Roboto, sans-serif',
  fontSize: '16px',
  padding: `8px 16px`,
  transition: '0.5s',
  ':hover': {
    backgroundColor: '#E8E9FD',
    cursor: 'pointer'
  }
})

export const AccountMenuButton = styled(Button)({
  color: '#0000FF',
  backgroundColor: 'transparent',
  transition: '0.5s',
  border: 'none',
  ':hover': {
    cursor: 'pointer'
  }
})

export const AccountMenu = styled(Menu)({
  position: 'fixed',
  left: '0',
  bottom: '58px',
  zIndex: '1',
  padding: `8px 48px`,
  borderRadius: 4,
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  minWidth: '160px',
  '&:active': {
    border: 'none'
  }
})

export const AccountMenuItem = styled(MenuItem)({
  whiteSpace: 'initial',
  color: '#fff',
  fontFamily: 'Roboto, sans-serif',
  fontSize: '16px',
  fontWeight: '600',
  marginBottom: 8,
  transition: '0.5s',
  ':hover': {
    color: '#A4AAFF',
    cursor: 'pointer'
  }
})
